var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    "class": {
      'input-style-tailwind': _vm.inputStyle === 'tailwind'
    }
  }, [_c('v-combobox', {
    ref: "field",
    "class": _vm.className,
    attrs: {
      "id": _vm.inputId,
      "items": _vm.countryOptions,
      "error-messages": _vm.errorMessages,
      "label": _vm.label,
      "disabled": _vm.disabled,
      "dense": _vm.dense,
      "clearable": _vm.clearable,
      "placeholder": _vm.placeholder,
      "persistent-placeholder": _vm.persistentPlaceholder,
      "filter": _vm.filterCountries,
      "search-input": _vm.search,
      "outlined": _vm.outlined,
      "background-color": _vm.backgroundColor,
      "loading": _vm.loading,
      "prepend-inner-icon": _vm.prependInnerIcon,
      "required": _vm.required,
      "flat": _vm.flat,
      "hide-details": _vm.hideDetails,
      "item-text": "name",
      "item-value": "code"
    },
    on: {
      "update:searchInput": function updateSearchInput($event) {
        _vm.search = $event;
      },
      "update:search-input": function updateSearchInput($event) {
        _vm.search = $event;
      },
      "input": _vm.handleInput,
      "change": _vm.handleChange
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [typeof item === 'string' ? _c('span', [_vm._v(_vm._s(_vm.$utils.getCountryName(item)))]) : _c('span', [_vm._v(_vm._s(_vm.$utils.getCountryName(item.code)))])];
      }
    }, {
      key: "item",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_c('span', [_vm._v(_vm._s(_vm.$utils.getCountryName(item.code)))])];
      }
    }]),
    model: {
      value: _vm.selectedCountry,
      callback: function callback($$v) {
        _vm.selectedCountry = $$v;
      },
      expression: "selectedCountry"
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }